import React, { useEffect, useState } from "react"

const GROUP_LABELS = {
  STRONG_FIT: "strong-fit candidates",
  POSSIBLE_FIT: "possible-fit candidates",
  WEAK_FIT: "weak-fit candidates",
}

const audienceCopy = ({ audience, group, selectedCount, candidateName, roleTitle }) => {
  if (audience === "INDIVIDUAL") {
    return `Send an email to ${candidateName || "this candidate"} about ${roleTitle || "this role"}.`
  }
  if (audience === "SELECTED") {
    return `Send one email to ${selectedCount} selected candidate${selectedCount === 1 ? "" : "s"}.`
  }
  if (audience === "GROUP") {
    return `Send one email to all ${GROUP_LABELS[group] || "candidates in this group"}.`
  }
  return `Send one email to every screened candidate with an email on their CV.`
}

const CvScreeningMessageComposer = ({
  open,
  onClose,
  audience,
  group,
  selectedCount = 0,
  candidateName = "",
  roleTitle = "",
  sending,
  error,
  onSend,
}) => {
  const [subject, setSubject] = useState("")
  const [body, setBody] = useState("")

  useEffect(() => {
    if (!open) return
    setSubject("")
    setBody("")
  }, [open, audience, group, candidateName])

  if (!open) return null

  const handleSubmit = (e) => {
    e.preventDefault()
    onSend({ subject: subject.trim(), body: body.trim() })
  }

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-slate-900/50 p-3 sm:items-center">
      <div
        className="absolute inset-0"
        onClick={sending ? undefined : onClose}
        aria-hidden="true"
      />
      <form
        onSubmit={handleSubmit}
        className="relative z-10 w-full max-w-lg overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl"
      >
        <div className="border-b border-slate-100 px-5 py-4">
          <h3 className="text-base font-semibold text-gray-900">Email candidates</h3>
          <p className="mt-1 text-xs text-gray-600">
            {audienceCopy({ audience, group, selectedCount, candidateName, roleTitle })}
          </p>
        </div>
        <div className="space-y-3 px-5 py-4">
          {error ? (
            <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-700">
              {error}
            </div>
          ) : null}
          <label className="block text-xs font-medium text-gray-700">
            Subject
            <input
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              maxLength={200}
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
              placeholder={`Message regarding ${roleTitle || "this role"}`}
            />
          </label>
          <label className="block text-xs font-medium text-gray-700">
            Message
            <textarea
              value={body}
              onChange={(e) => setBody(e.target.value)}
              required
              rows={7}
              maxLength={8000}
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
              placeholder="Write the email candidates will receive..."
            />
            <span className="mt-1 block font-normal text-[11px] text-gray-500">
              Optional placeholders: {"{{name}}"}, {"{{role}}"}, {"{{company}}"}
            </span>
          </label>
        </div>
        <div className="flex justify-end gap-2 border-t border-slate-100 bg-slate-50 px-5 py-3">
          <button
            type="button"
            onClick={onClose}
            disabled={sending}
            className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={sending || !body.trim()}
            className="rounded-lg bg-black px-4 py-2 text-sm font-semibold text-white hover:bg-gray-900 disabled:opacity-50"
          >
            {sending ? "Sending..." : "Send email"}
          </button>
        </div>
      </form>
    </div>
  )
}

export default CvScreeningMessageComposer
